import { useRouter } from 'next/router'
import DEFAULT_META_TAGS from '@/constants/meta'

export default function useCanonicalUrl() {
  const { asPath } = useRouter()
  const canonicalUrl = `${DEFAULT_META_TAGS.url}${asPath}`.split('?')[0]
  return canonicalUrl
}
